import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import MenuItem from "../menu-item/menu-item";
import Icon from "components/icon";
import { useCustomThemeContext } from "components/mui-providers";
import { IconMenuItem } from "components/icon-menu";

const MenuHelpEntry = ({ intl, iconMenu = false, selected }) => {
  const { customTheme } = useCustomThemeContext();

  const Component = iconMenu ? IconMenuItem : MenuItem;

  return (
    <Component
      selected={selected}
      url={customTheme.helpUrl}
      target="admin_tiivii_help"
      text={intl.formatMessage({ id: "app.menu.help" })}
    >
      <Icon name="live-help" />
    </Component>
  );
};

MenuHelpEntry.propTypes = {
  /**
   * Indica si se aplican los estilos del menú de iconos
   */
  iconMenu: PropTypes.bool,
  /**
   * Indica si la entrada de menú está seleccionada
   */
  selected: PropTypes.bool,
};

export default injectIntl(MenuHelpEntry);
